<template>
  <v-layout row wrap pa-3>
    <v-flex xs12>
      <v-layout row wrap main-section>
        <v-flex xs12 pt-3>
          <v-card-title>
            <!-- <h3 class="halfwhite-text">
              {{ $store.getters.getHeadingForBalanceBlock }}
            </h3> -->
            <v-icon>mdi-chart-bar</v-icon>
            <h4 class="headline halfwhite-text ml-2">Analytics</h4>
          </v-card-title>
          <v-flex xs12 style="margin-top: -60px">
            <v-tabs
              right
              color="transparent"
              slider-color="transparent"
              no-animation
              active-class="tab-active"
              class="rounded-tl rounded-tr"
            >
              <!-- <v-tab><span>Ovations</span></v-tab> -->
              <!-- <v-tab><span>Store</span></v-tab> -->
              <v-tab-item :lazy="true" :transition="false">
                <OvationsAnalytics></OvationsAnalytics>
              </v-tab-item>
              <!-- <v-tab-item :lazy="true" :transition="false">
                <StoreAnalytics></StoreAnalytics>
              </v-tab-item> -->
            </v-tabs>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import OvationsAnalytics from "@/views/OvationsAnalytics.vue";
//import StoreAnalytics from "@/views/StoreAnalytics.vue";

export default {
  name: "OvationAnalytics",
  components: { OvationsAnalytics },
  data() {
    return {};
  },
  methods: {},
  beforeMount() {},
};
</script>
